import React, { useContext } from "react";

//Style
import { makeStyles } from "@material-ui/core/styles";

//Component
//--> Drawer
import SideDrawer from "../components/Drawer/SideDrawer";
//--> Cover
import Cover from "../components/Cover/Cover";
//--> Title
import Title from "../components/Title";
//--> Counter
import Counter from "../components/Counter/Counter";
//--> Profile
import Profile from "../components/Profile/Profile";

//Context
import { AgentContext } from "../context/AgentContext";
import { ClientContext } from "../context/ClientContext";

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
}));

export default function Dashboard() {
  const classes = useStyles();

  //Context
  const { agentsCount } = useContext(AgentContext);
  const { clientsCount, taskCount, taskDoneCount } = useContext(ClientContext);

  const counter = [
    {
      label: "Agents",
      number: agentsCount,
      duration: 2,
    },
    {
      label: "Clients",
      number: clientsCount,
      duration: 2,
    },
    {
      label: "Task Assigned",
      number: taskCount,
      duration: 2,
    },
    {
      label: "Task Completed",
      number: taskDoneCount,
      duration: 2,
    },
  ];

  return (
    <div style={{ display: "flex", backgroundColor: "#F3F4F7" }}>
      <SideDrawer />
      <div style={{ flex: 1 }}>
        <div className={classes.toolbar} />
        <Cover title="Admin Dashboard" />
        <div className={classes.content}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexFlow: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="counterContainer">
              <Title title="Total Number of" overlay="Track" />
              <div className="counterSubcontainer">
                {counter.map((data, index) => {
                  return <Counter data={data} key={index} />;
                })}
              </div>
            </div>
            <Profile />
          </div>
        </div>
      </div>
    </div>
  );
}
